/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {addSyncEntity} from '../api'

export const useMutationAddSyncEntity = createReactQueryMutationHook('addSyncEntity', addSyncEntity)
